import axios from '@/request'

// 获取用户列表
export function getUserList(data) {
    return axios({
        url: '/user/getUserList',
        method: 'post',
        data: data
    })
}

export function getUserInfo() {
    return axios({
        url: '/sys/sys_user/find',
        method: 'get'
    })
}

// 获取路由
export function getRouters() {
    return axios({
        url: '/sys/sys_menu/authmenu',
        method: 'get',
    })
}

// 退出登录
export function logout() {
    return axios({
        url: '/sys/sys_user/loginout',
        method: 'get',
    })
}
